export const contentBottom = {
  'addCheckFields': {
    'name': '名称'
  },
  'addTimeLong': null,
  'beginTime': null,
  'endTime': null,
  'like': null,
  'pageSize': 100,
  'pageNum': 1,
  'id': null,
  'n': null,
  'd': null,
  'mss': '{"ms":[{"c":"Company address: SUITE 9A 9/F HENNESSY PLAZA 164-166 HENNESSY ROAD WANCHAI HK","t":"","u":""},{"c":"ICP证渝B2-20240202 | 渝ICP备19005455号-1","t":"","u":""},{"c":"Copyright© 2024 NEMOJOY TECH CO., LIMITED. All rights reserved.","t":"","u":""}],"l":{"c":"/nemojoyWebSiteFile/imgs/indexBottom/1618464997371bottomLogo.png","u":"/index"},"us":[]}',
  'l': {
    't': null,
    'c': '/nemojoyWebSiteFile/imgs/indexBottom/1618464997371bottomLogo.png',
    'u': '/index'
  },
  'us': [],
  'ms': [
    {
      't': '',
      'c': 'Company address: SUITE 9A 9/F HENNESSY PLAZA 164-166 HENNESSY ROAD WANCHAI HK',
      'u': ''
    },
    {
      't': '',
      'c': 'Copyright© 2024 NEMOJOY TECH CO., LIMITED. All rights reserved.',
      'u': ''
    }
  ],
  'is': []
}
